export type ReceiptTypeConfig = {
  id: string;
  name: string;
  color: string;
  textColor: string;
  default?: boolean;
  ocrModel?: string;
}

export const OCR_MODELS = [
  { id: 'prebuilt-receipt', name: 'Receipt' },
  { id: 'prebuilt-invoice', name: 'Invoice' },
  { id: 'prebuilt-layout', name: 'General' },
  { id: 'prebuilt-idDocument', name: 'ID document' },
] as const;

export const DEFAULT_RECEIPT_TYPES: ReceiptTypeConfig[] = [
  { id: '11111111-1111-1111-1111-111111111111', name: 'Receipt', color: 'bg-blue-500', textColor: 'text-white', default: true, ocrModel: 'prebuilt-receipt' },
  { id: '22222222-2222-2222-2222-222222222222', name: 'Invoice', color: 'bg-green-500', textColor: 'text-white', default: false, ocrModel: 'prebuilt-invoice' },
];

export const AVAILABLE_COLORS = [
  { name: 'Blue', value: 'bg-blue-500', textColor: 'text-white' },
  { name: 'Green', value: 'bg-green-500', textColor: 'text-white' },
  { name: 'Purple', value: 'bg-purple-500', textColor: 'text-white' },
  { name: 'Orange', value: 'bg-orange-500', textColor: 'text-white' },
  { name: 'Pink', value: 'bg-pink-500', textColor: 'text-white' },
  { name: 'Cyan', value: 'bg-cyan-500', textColor: 'text-white' },
  { name: 'Teal', value: 'bg-teal-500', textColor: 'text-white' },
  { name: 'Yellow', value: 'bg-yellow-500', textColor: 'text-gray-900' },
  { name: 'Red', value: 'bg-red-500', textColor: 'text-white' },
  { name: 'Indigo', value: 'bg-indigo-500', textColor: 'text-white' },
  { name: 'Gray', value: 'bg-gray-500', textColor: 'text-white' },
];

export function getReceiptTypeConfig(typeIdOrName: string): ReceiptTypeConfig | undefined {
  if (!typeIdOrName || typeof typeIdOrName !== 'string') return undefined;
  return DEFAULT_RECEIPT_TYPES.find(
    (type) => type.id === typeIdOrName || type.name.toLowerCase() === typeIdOrName.toLowerCase()
  );
}

export function getReceiptTypeLabel(typeName: string): string {
  if (!typeName || typeof typeName !== 'string') return 'Other';
  const labels: Record<string, string> = {
    Receipt: 'Receipt',
    Invoice: 'Invoice',
  };
  return labels[typeName] || typeName;
}
